import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HarmonizedShapesComponent } from './harmonized-shapes.component';

@NgModule({
  imports: [CommonModule, HarmonizedShapesComponent],
  exports: [HarmonizedShapesComponent],
})
export class HarmonizedShapesModule {}
